
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
// router setup
import { BootstrapVueIcons } from 'bootstrap-vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
//Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import './registerServiceWorker'
import store from './store'
// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)

// configure router
import router from './routes/routes'

import VueLayers from 'vuelayers'
import 'vuelayers/dist/vuelayers.css'
Vue.use(VueLayers)


import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar);
import CountryFlag from 'vue-country-flag'

Vue.component('country-flag', CountryFlag)

Vue.config.productionTip = false;
Vue.config.devtools = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

